import { storeToRefs } from 'pinia'

export default defineNuxtPlugin(() => {
    const handler = async (event: MessageEvent) => {
        const payload = event.data
        const isMatch = payload === 'entry:live-preview:updated' || (payload && payload.type === 'entry:live-preview:updated')
        if (!isMatch) return

        try {
            const entryStore = useEntryStore()
            const route = useRoute()
            const { uri } = storeToRefs(useGlobalStore())

            if (!uri.value) return

            await entryStore.loadEntry(uri.value, { 
                routeQuery: route?.query,
                server: false,
            })
        } catch (err) {
            console.error('live-preview: reload failed', err)
        }
    }

    const { isPreview } = storeToRefs(usePreview())

    if (isPreview?.value) {
        window.addEventListener('message', handler)

        // cleanup when app unloads
        window.addEventListener('unload', () => {
            window.removeEventListener('message', handler)
        })
    }   
})
